import { useNavigate } from "react-router-dom";
import Logo from "../assets/nav-logo.svg";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="font-sans">
      {/* Navbar */}
      <nav className="px-0 md:px-6 py-4 bg-black shadow-md">
        <div className="container mx-auto flex justify-between items-center">
          <div
            onClick={() => navigate("/")}
            className="flex justify-between items-center cursor-pointer"
          >
            <img src={Logo} alt="JP Associates" className="h-14 w-14 mr-1" />
            <div className="md:text-xl font-bold text-green">JP Associates</div>
          </div>

          <button
            onClick={() => navigate("/login")}
            className="px-4 py-2 bg-green text-offwhite cursor-pointer rounded hover:bg-[#12a866] transition-colors"
          >
            Sign in
          </button>
        </div>
      </nav>

      {/* Text Section */}
      <section className="bg-[#f3f3f3] py-8 px-0 md:px-6 md:py-20">
        <div className="container mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold text-[rgb(7,2,13)] mb-6">
            Privacy Policy
          </h1>
          <p className="text-lg md:text-xl text-[rgb(7,2,13)] md:mb-8 md:mr-2">
            <strong>Introduction</strong>
            <br />
            Welcome to the JP Associates portal (the "Portal"). Our platform is
            designed to facilitate the exchange of images and information
            between buyers and sellers, helping them reach thousands of
            potential counterparts efficiently. By submitting images and
            associated details through the Portal, users benefit from increased
            visibility and a streamlined communication process.
            <div className="m-1" />
            JP Associates aims to enhance market accessibility by circulating
            submitted images to a wide network of interested parties. Our
            customer service team may also assist by posting on behalf of users
            upon explicit authorization via email or other approved
            communication channels.
            <br />
            <br />
            <strong>Terms of Use</strong>
            <br />
            By accessing or using the Portal, you ("User") agree to the
            following terms:
            <br />
            <br />
            <strong>Submission and Use of Content</strong>
            <br />
            Users submitting images and related content ("Content") grant JP
            Associates a non-exclusive, royalty-free, worldwide license to use,
            modify, distribute, and circulate the Content to other potential
            buyers and sellers.
            <div className="m-1" />
            Users affirm that they have the necessary rights to share the
            Content and that it does not infringe any third-party rights.
            <div className="m-1" />
            JP Associates reserves the right to edit Content for clarity,
            formatting, or categorization purposes without altering its
            fundamental nature.
            <br />
            <br />
            <strong>Indemnification and Liability</strong>
            <br />
            JP Associates acts as an intermediary and assumes no liability for
            the accuracy, ownership, or legality of the Content submitted.
            <div className="m-1" />
            Users agree to indemnify and hold harmless JP Associates, its
            employees, agents, and affiliates from any claims, damages, or
            liabilities arising from the submission, modification, or
            circulation of their Content.
            <div className="m-1" />
            JP Associates is not responsible for any disputes arising between
            users concerning Content ownership, validity, or accuracy.
            <br />
            <br />
            <strong>Content Moderation</strong>
            <br />
            JP Associates reserves the right to remove, reject, or modify any
            Content that violates applicable laws, infringes intellectual
            property, or is deemed inappropriate or misleading.
            <div className="m-1" />
            Users acknowledge that JP Associates does not guarantee the sale,
            purchase, or transaction of any goods or services based on the
            Content submitted.
            <br />
            <br />
            <strong>Privacy and Data Protection</strong>
            <br />
            Users' personal information will be handled in accordance with our
            Privacy Policy.
            <div className="m-1" />
            JP Associates may store, process, and share user data strictly for
            the purpose of operating and enhancing the Portal's services.
            <div className="m-1" />
            Personal details will not be sold or shared with third parties for
            unrelated commercial purposes.
            <br />
            <br />
            <strong>Modifications and Updates</strong>
            <br />
            JP Associates reserves the right to update these Terms of Use and
            the Privacy Agreement at any time. Users will be notified of
            significant changes.
            <div className="m-1" />
            Continued use of the Portal after updates constitutes acceptance of
            the revised terms.
            <br />
            <br />
            <strong>Privacy Agreement</strong>
            <br />
            <br />
            <strong>Collection of Information</strong>
            <br />
            Users may be required to provide certain personal details, including
            but not limited to name, email, and contact information, to utilize
            the Portal effectively.
            <div className="m-1" />
            The Portal may collect non-personally identifiable data such as
            browsing behavior, device information, and usage statistics to
            improve user experience.
            <br />
            <br />
            <strong>Use of Information</strong>
            <br />
            User information is used solely to facilitate transactions,
            communicate updates, and enhance the functionality of the Portal.
            <div className="m-1" />
            JP Associates will not sell, rent, or distribute user data to third
            parties, except as necessary for legal compliance or to provide
            Portal-related services.
            <br />
            <br />
            <strong>Security Measures</strong>
            <br />
            Reasonable security practices are in place to protect user data from
            unauthorized access, alteration, or disclosure.
            <div className="m-1" />
            Despite these measures, JP Associates cannot guarantee absolute
            security and encourages users to exercise caution when sharing
            sensitive information.
            <br />
            <br />
            <strong>User Rights</strong>
            <br />
            Users may request access to, correction of, or deletion of their
            personal data stored by JP Associates, subject to applicable laws.
            <div className="m-1" />
            Requests can be directed to our customer service team through the
            provided contact channels.
            <br />
            <br />
            <strong>Legal Compliance</strong>
            <br />
            JP Associates complies with applicable data protection and privacy
            laws and will cooperate with legal authorities if required.
            <div className="m-1" />
            By using the Portal, users acknowledge and agree to these Terms of
            Use and Privacy Agreement. If you do not agree to these terms,
            please refrain from using the Portal.
            <div className="m-1" />
            For any inquiries or concerns regarding these terms, please contact
            JP Associates at{" "}
            <span className="text-blue-600">info@jpassociates.biz</span>.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 px-6 bg-[rgb(7,2,13)] text-white text-center">
        <p className="mb-2">© 2025 JP Associates. All rights reserved.</p>
        <div className="space-x-4">
          <a href="/terms-of-use" className="hover:underline">
            Terms of Use
          </a>
          <a href="/privacy-policy" className="hover:underline">
            Privacy Policy
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
